<!-- Desktop Version -->
<div
    class="tw-hidden xl:tw-flex tw-flex-row tw-gap-[30px] tw-justify-center tw-bg-[#D9D9D94D] tw-py-[70px] tw-pl-[80px] tw-pr-[80px]"
>
    <div
        class="tw-flex tw-flex-col tw-gap-[12px] tw-justify-center tw-py-[50px] tw-min-w-[383px] tw-max-w-[383px]"
    >
        <span
            class="tw-text-[28px] tw-font-bold tw-leading-[140%] tw-text-[#024B3F] tw-text-start"
            >{{ sectionTitle }}</span
        >
        <span
            class="tw-text-[13px] tw-font-normal tw-leading-[19px] tw-text-[#1A202C] tw-text-start"
            >Learn ESG basics and how it applies to you and Check Your Readiness
            - Use the checklist to see where you stand and Take Action - Follow
            the steps to make small changes in your business</span
        >
    </div>
    <!-- Simple Carousel Container -->
    <div
        class="tw-relative tw-flex tw-items-center tw-gap-[20px] tw-max-w-full"
    >
        <!-- Carousel with reduced width -->
        <div class="tw-flex-1 tw-pr-[20px] tw-max-w-[830px]">
            <p-carousel
                #carousel
                [value]="smeSuccessStories"
                [numVisible]="1"
                [numScroll]="1"
                [circular]="true"
                [showNavigators]="false"
                [showIndicators]="true"
                class="simple-carousel"
                (onPage)="onCarouselPageChange($event)"
            >
                <!-- Hide Previous Button -->
                <ng-template pTemplate="previousicon">
                    <div class="tw-hidden"></div>
                </ng-template>

                <!-- Hide Default Next Button -->
                <ng-template pTemplate="nexticon">
                    <div class="tw-hidden"></div>
                </ng-template>

                <!-- Carousel Item Template -->
                <ng-template let-item pTemplate="item">
                    <div class="tw-w-full tw-h-full">
                        <app-success-story-item
                            [image]="item.image"
                            [portrait]="item.pImage"
                            [mobile]="item.mImage"
                            [title]="item.title"
                            [description]="item.description"
                            [shortdesc]="item.shortdesc"
                            [storyData]="item"
                            (itemClick)="openModal($event)"
                            class="tw-w-full tw-h-full"
                        ></app-success-story-item>
                    </div>
                </ng-template>
            </p-carousel>
        </div>

        <!-- Custom Next Button with Gap -->
        <div
            *ngIf="smeSuccessStories?.length > 1"
            class="tw-flex-shrink-0"
            (click)="goToNext()"
        >
            <div
                class="tw-w-[35px] tw-h-[35px] tw-bg-white tw-border-[1.5px] tw-border-[#4B6EEC] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-shadow-lg tw-cursor-pointer hover:tw-scale-110 tw-transition-all tw-duration-200"
            >
                <mat-icon
                    fontIcon="chevron_right"
                    class="tw-text-[#4B6EEC] !tw-text-[20px] !tw-w-[20px] !tw-h-[20px] !tw-leading-[20px] tw-flex tw-items-center tw-justify-center"
                ></mat-icon>
            </div>
        </div>
    </div>
</div>

<!-- Mobile/Tablet Version -->
<div
    class="tw-block xl:tw-hidden tw-bg-[#D9D9D94D] tw-py-[50px] tw-px-[20px] sm:tw-px-[30px] md:tw-px-[48px]"
>
    <div
        class="tw-flex tw-flex-col tw-gap-[15px] sm:tw-gap-[20px] tw-px-[10px] sm:tw-px-[20px] tw-mb-[25px] sm:tw-mb-[30px]"
    >
        <span
            class="tw-text-[18px] sm:tw-text-[20px] md:tw-text-[22px] lg:tw-text-[28px] tw-font-bold tw-leading-[24px] sm:tw-leading-[28px] md:tw-leading-[140%] tw-text-[#024B3F] tw-text-left"
        >
            {{ sectionTitle }}
        </span>
        <span
            class="tw-text-[12px] sm:tw-text-[13px] md:tw-text-[14px] tw-font-normal tw-leading-[17px] sm:tw-leading-[18px] md:tw-leading-[19px] tw-text-[#1A202C] tw-text-left sm:tw-max-w-[400px] md:tw-max-w-[600px]"
        >
            Learn ESG basics and how it applies to you and Check Your Readiness
            - Use the checklist to see where you stand and Take Action - Follow
            the steps to make small changes in your business
        </span>
    </div>

    <app-mobile-sme-stories
        [smeSuccessStories]="smeSuccessStories"
        (storyClick)="openModal($event)"
    ></app-mobile-sme-stories>
</div>

<!-- Success Story Modal -->
<app-success-story-modal
    [isVisible]="isModalVisible"
    [storyData]="selectedStory"
    (closeModal)="closeModal()"
></app-success-story-modal>
